import React from 'react';
import Context from '../../contexts/MarketPerformanceContext';

const MarketGroupsNav = () => {
    return (
        <Context.Consumer>
            { (context) => (
                <div className="market-groups">
                    <ul className="nav nav-tabs">
                        { context.state.tabs.map((tab, index) => {
                            return (
                                <li className="nav-item" key={ index }>
                                    <button
                                        type="button"
                                        className={ `nav-link ${(tab.id === context.state.currentTabId ? ' active' : '')}` }
                                        onClick={ () => {
                                            context.setCurrentTab(tab.id);
                                        } }
                                    >{ tab.name }</button>
                                </li>
                            );
                        }) }
                    </ul>
                </div>
            ) }
        </Context.Consumer>
    );
};

export default MarketGroupsNav;
